module.exports = __webpack_public_path__ + "static/media/roundGreenTick.b2bea1ab.png";